<template>
  <el-dialog title="修改手机号" :visible.sync="showMobile" width="400px" @closed="onClose" :append-to-body="true" :lock-scroll="false">
    <el-form :model="form" ref="form" :rules="rules" label-width="82px" @keyup.enter.native="save">
      <el-form-item label="手机号:" prop="mobile">
        <el-input v-model="form.mobile" placeholder="请输入手机号" maxlength="11" clearable />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { updateTeacherMobile } from '@/config/api';

  export default {
    name: 'EleMobile',
    data() {
      return {
        form: {
          mobile: JSON.parse(sessionStorage.getItem('user')).mobile,
        },
        rules: {
          // 表单验证
          mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        },
        loading: false, // 按钮loading
      };
    },
    computed: {
      showMobile: {
        get() {
          return this.$store.state.theme.showMobile;
        },
        set(val) {
          this.$store.dispatch('theme/set', { key: 'showMobile', value: val });
        },
      },
    },
    methods: {
      save() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.loading = true;
            let data = new FormData();
            for (let key in this.form) {
              if (this.form[key] !== null && this.form[key] !== undefined) {
                data.append(key, this.form[key]);
              }
            }
            updateTeacherMobile(data)
              .then((res) => {
                this.loading = false;
                if (res.data.resCode == 200) {
                  this.$message({ type: 'success', message: '修改手机成功' });
                  this.cancel();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              })
              .catch((e) => {
                this.loading = false;
                this.$message.error(e.message);
              });
          } else {
            return false;
          }
        });
      },
      /* 取消 */
      cancel() {
        this.$store.dispatch('theme/toggle', 'showMobile');
      },
      /* 关闭回调 */
      onClose() {
        this.form = {};
        this.loading = false;
        this.$refs['form'].resetFields();
      },
    },
  };
</script>

<style scoped></style>
